const environments = {
    dev: {
      aws_project_region: "us-west-1",
      aws_cognito_region: "us-west-1",
      aws_user_pools_id: "us-west-1_Y6546BSj9", // ✅ Updated User Pool ID from CDK output
      aws_user_pools_web_client_id: "2qdd12b9r3ibtkm0tjjb1j5fv9", // ✅ Updated User Pool Client ID from CDK output
      oauth: {},
      aws_cognito_username_attributes: ["EMAIL"],
      aws_cognito_signup_attributes: ["EMAIL", "NAME"],
      aws_cognito_mfa_configuration: "OFF",
      aws_cognito_mfa_types: ["SMS"],
      aws_cognito_password_protection_settings: {
        passwordPolicyMinLength: 8,
        passwordPolicyCharacters: [],
      },
      aws_cognito_verification_mechanisms: ["EMAIL"],
    }
  };
  
  // 🔹 Detect environment from `window.location.hostname`
  const hostname = window.location.hostname;
  let env = "dev"; // Default to dev
  
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    env = "dev";  // Explicitly use `dev` for localhost
  } else if (hostname === "dev.studio.guardify.com") {
    env = "dev";  // Explicitly map CloudFront dev domain to `dev`
  }
  
  // Export the correct environment config
  const awsConfig = environments[env];
  
  console.log("🔹 Amplify using environment:", env);
  console.log("🔹 Cognito Config:", awsConfig);
  
  export default awsConfig;
  